$( document ).ready(function() {
    // Handler for .ready() called.
    $("#cart-notification").removeClass("color-background-2");
    $("#cart-notification").addClass("color-background-1");
  });


(() => {
    const cookiePrefix = 'CognitoIdentityServiceProvider';
    document.addEventListener('DOMContentLoaded', () => {
        const logoutBtn = document.querySelector('a[href^="/account/logout"]');
        console.log('Listening for logout action');
        if (logoutBtn) {
            logoutBtn.addEventListener('click', (event) => {
                try {
                    console.log('Logout purging cookies');
                    const cookies = document.cookie.split('; ');
                    cookies.forEach(cookie => {
                        if (cookie.startsWith(cookiePrefix)) {
                            const cookieName = cookie.split('=')[0];
                            // Ensure the cookie is removed from the root domain
                            document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.celticfc.com;';
                        }
                    });
                } catch (e) {
                    console.log(e);
                    console.log('Logout failed');
                }
            });
        }
    });
})();